const getLookupDropdownList = (data: any, isExamEligibleForUkVisa = false) => {
  let countries = [];
  let genders = [];
  let specialRequirements = [];
  let reasons = [];
  if (data) {
    for (const [key, value] of Object.entries(data?.addressCountries)) {
      countries.push({ label: value, value: key });
    }
    for (const [key, value] of Object.entries(data?.genders)) {
      genders.push({ label: value, value: key });
    }
    for (const [key, value] of Object.entries(data?.reasonForExam)) {
      if (!isExamEligibleForUkVisa && key === "1"){
        continue
      }else{
        reasons.push({ label: value, value: key });
      }
    }
    for (const [key, value] of Object.entries(data?.specialRequirements)) {
      specialRequirements.push({ label: value, value: key });
    }
  }
  
  return { countries, genders, reasons, specialRequirements };
};

export default getLookupDropdownList;
